import {
  createBrowserRouter,
  RouterProvider,
  Navigate,
} from "react-router-dom";
import { globalRoutes } from "./paths";
import publicRoutes from "./public";
import privateRoutes from "./private";

import { useSelector } from "react-redux";

const Router = () => {
  const router = () =>
    createBrowserRouter([
      ...publicRoutes,
      ...privateRoutes.map((route, index) => {
        return {
          ...route,
          element: <PrivateRoute>{route.element}</PrivateRoute>,
        };
      }),
      ...globalRoutes,
    ]);

  return <RouterProvider router={router()} />;
};

export default Router;

const PrivateRoute = ({ children, ...rest }) => {
  const token = useSelector((state) => state.token);

  let auth = token != null;

  return auth ? children : <Navigate to="/" />;
};
